export default {
  CLO_FIRST_TRANSACTION_BONUS_02_01_2019_RUNNING_LOW: 'clo_first_transaction_bonus_02_01_2019_running_low',
  CLO_FIRST_TRANSACTION_BONUS_02_01_2019_RAN_OUT: 'clo_first_transaction_bonus_02_01_2019_ran_out',
  CLO_FIRST_TRANSACTION_BONUS_02_01_2019_USER_QUALIFIES: 'clo_first_transaction_bonus_02_01_2019_user_qualifies',
  CLO_FIRST_TRANSACTION_BONUS_02_01_2019_USER_RECEIVED: 'clo_first_transaction_bonus_02_01_2019_user_received'
};